import React from 'react';
import { Button, Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedChartId } from '../MetricsChartContainer/utils';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import { selectedMetricChart } from '@store/metricsChartContainer/actions';
import { selectedMetricSelector } from '@src/store/metricsChartContainer/selectors';
import { SWAP_METRIC } from '@src/utils/sensor/track';
import apptracker from '@src/utils/sensor/apptracker';

function AddMetricToTable({ metric }) {
  const dispatch = useDispatch();
  const selectedMetric = useSelector(selectedMetricSelector);

  const handleClick = (event) => {
    event.stopPropagation();
    const chartId = getSelectedChartId(metric);
    if (chartId) {
      const newMetric = getInvertedPercentageMetricByKey({
        metricKey: metric,
        defaultValue: metric,
      });
      dispatch(selectedMetricChart(newMetric, chartId, false));
      apptracker(SWAP_METRIC, { metric: newMetric });
    }
  };

  return (
    selectedMetric !== metric && (
      <Tooltip placement="topRight" title={'Replace metrics in dimension tables'}>
        <Button
          size="small"
          type="text"
          icon={<SwapOutlined style={{ color: '#6e6e6e' }} />}
          onClick={handleClick}
        />
      </Tooltip>
    )
  );
}

export default AddMetricToTable;
